/**
 * The filled circle with a knocked-out check beside a success message. Figma 10188:14962
 * ("options_on"), drawn at 16px in Helper message 10188:18315; the path is the filled variant of
 * Fusion's `OptionsOnIcon` (fusion.atoms.icons/components/options.tsx), copied as data, not imported.
 * Same 36-unit box as `options-off-glyph.ts`, so both icons draw the same 8px circle at 16px.
 * The fill is `currentColor` at the call site.
 */
export const OPTIONS_ON_GLYPH_VIEWBOX = "0 0 36 36";

export const OPTIONS_ON_GLYPH_PATH =
  "M18 9C13.03 9 9 13.03 9 18C9 22.97 13.03 27 18 27C22.97 27 27 22.97 27 18C27 13.03 22.97 9 18 9ZM23.12 " +
  "14.16L17.66 22.95C17.46 23.27 17.12 23.46 16.76 23.46C16.44 23.46 16.13 23.31 15.92 23.05L12.56 18.83C12.29 " +
  "18.49 12.33 18 12.64 17.7C12.95 17.41 13.46 17.41 13.77 17.69L16.62 20.26L21.72 13.22C21.97 12.87 22.5 " +
  "12.78 22.86 13.02C23.23 13.27 23.34 13.77 23.1 14.15L23.12 14.16Z";
